// eslint-disable-next-line no-undef
const isFullScreen = () => document.fullscreenElement || document.webkitFullscreenElement;

export default isFullScreen;
